import React, { FC } from "react";

import LocalePicker from "nvent-web/scenes/Auth/components/LocalePicker";

import style from "./AnonymousHeader.module.scss";

export const AnonymousHeader: FC = () => (
  <>
    <div className={style.placeholder} />
    <div className={style.root}>
      <div className={style.container}>
        <div className={style.logo} />
        <div className={style.spark} />
        <div className={style.picker}>
          <LocalePicker dark />
        </div>
      </div>
    </div>
  </>
);
